import { path } from 'constants/operators';
import queryInitials from 'constants/queryInitials';

export const beautifyPageviewOperators = (input, operators) => {
  const content = queryInitials.filter(item => {
    if (typeof input[item.name] === 'undefined' && !operators[item.name]) {
      return false;
    }
    if (operators[item.name] && operators[item.name].type === 'EMPTY') {
      return false;
    } else if (!operators[item.name]) {
      const op = path.find(t => t.value === item.initial);
      if (op.type === 'EMPTY') {
        return false;
      }
    }
    return true;
  }).map((item) => {
    let finalOperator = '';
    let value = '';
    value = (input[item.name] && input[item.name].trim()) ? input[item.name] : '';
    if (operators[item.name]) {
      finalOperator = operators[item.name];
    } else {
      finalOperator = path.find(t => t.value === item.initial);
    }
    let config = {
      name: item.name,
      operator: finalOperator,
      value: item.case === 'sensitive'? value : value.toLowerCase()
    };
    return normalize(config);
  });
  return content;
};

function normalize (item) {
  if (item.value && (item.name === 'query' || item.name === 'hash')) {
    let {operator} = item;
    let prefix = item.name === 'query' ? '?' : '#';
    if (operator.value === '=' || operator.value === '<>') {
      if (item.value.charAt(0) !== prefix) {
        item.value = `${prefix}${item.value}`;
      }
    }
  }
  return item;
}



/** WEBPACK FOOTER **
 ** ./src/utils/operatorPurge.js
 **/